import Model, { attr } from '@ember-data/model';
import TorqueFormats from 'eflex/constants/torque-formats';
import { validator, buildValidations } from '@eflexsystems/ember-tracked-validations';

@buildValidations({
  textToSpeechRate: [validator('number', { gte: 0, lte: 10, allowString: true })],
  textToSpeechPitch: [validator('number', { gte: 0, lte: 2, allowString: true })],
})

class JemSystemConfig extends Model {
  @attr('string', { defaultValue: TorqueFormats.NEWTON_METER.label }) torqueFormat;
  @attr('string') textToSpeechVoice;
  @attr('number', { defaultValue: 1 }) textToSpeechRate;
  @attr('number', { defaultValue: 1 }) textToSpeechPitch;
  @attr('number', { defaultValue: 1 }) textToSpeechVolume;
  @attr('boolean', { defaultValue: false }) configurationHistory;
}
export default JemSystemConfig;

